"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientMergeModal = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const select_1 = require("client/components/material/select");
const modal_1 = require("client/components/modal");
const form_1 = require("client/components/ui/form");
const store_1 = require("client/modules/patients/store");
const material_ui_1 = require("material-ui");
const material_ui_icons_1 = require("material-ui-icons");
const Card_1 = require("material-ui/Card");
const transitions_1 = require("material-ui/transitions");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const React = require("react");
const logger_1 = require("shared/logger");
const throttle_debounce_1 = require("throttle-debounce");
require("./patient-merge-modal.less");
const log = new logger_1.Logger("patient-merge-modal");
var PatientDataIndex;
(function (PatientDataIndex) {
    PatientDataIndex[PatientDataIndex["FirstName"] = 0] = "FirstName";
    PatientDataIndex[PatientDataIndex["MiddleName"] = 1] = "MiddleName";
    PatientDataIndex[PatientDataIndex["LastName"] = 2] = "LastName";
    PatientDataIndex[PatientDataIndex["Address"] = 3] = "Address";
    PatientDataIndex[PatientDataIndex["City"] = 4] = "City";
    PatientDataIndex[PatientDataIndex["State"] = 5] = "State";
    PatientDataIndex[PatientDataIndex["Zipcode"] = 6] = "Zipcode";
    PatientDataIndex[PatientDataIndex["Email"] = 7] = "Email";
    PatientDataIndex[PatientDataIndex["Gender"] = 8] = "Gender";
    PatientDataIndex[PatientDataIndex["Birthdate"] = 9] = "Birthdate";
    PatientDataIndex[PatientDataIndex["Notes"] = 10] = "Notes";
    PatientDataIndex[PatientDataIndex["Phone"] = 11] = "Phone";
})(PatientDataIndex || (PatientDataIndex = {}));
const columns = [
    {
        id: "id",
        label: "Patient Id"
    },
    // C-076 open
    {
        id: "lastName",
        label: "Last Name"
    },
    {
        id: "firstName",
        label: "First Name"
    },
    // C-076 close
    {
        id: "birthdate",
        label: "Birthdate"
    }
];
let PatientMergeModal = class PatientMergeModal extends React.Component {
    constructor() {
        super(...arguments);
        this.allInsurances = [];
        this.currentPrimaryInsuranceId = "";
        this.showMergeConfirmation = false;
        this.errorMessage = "";
        this.similarPatients = [];
        this.showSearchParameters = true;
        this.displaySelectUi = true;
        this.checkedPatients = new Map();
        this.newMergedPatient = new Map();
        this.searchParameters = {
            firstName: true,
            middleName: false,
            lastName: true,
            birthDate: false,
            address: false,
            city: false,
            email: false,
            gender: false
        };
        this.loadSimilarPatients = throttle_debounce_1.debounce(200, async () => {
            const { id: patientId, sites: [site] } = this.props.patient;
            if (!site) {
                console.error("site not found in loadSimilarPatients");
                return;
            }
            const query = {
                patientId,
                siteId: site.id,
                searchable: this.getSearchables()
            };
            this.similarPatients = await store_1.patientsStore.loadSimilarPatients(query);
            this.initializeCheckedPatients();
        });
        this.getSearchables = () => Object.keys(this.searchParameters).filter(key => this.searchParameters[key]);
        this.initializeCheckedPatients = () => {
            this.checkedPatients.clear();
            for (const patient of this.similarPatients) {
                this.checkedPatients.set(patient.id, false);
            }
        };
        this.initializePrimaryInsurance = () => {
            const currentPrimarryInsurance = this.props.patient.insurances.find(insurance => insurance.primaryInsurance);
            if (currentPrimarryInsurance) {
                // this.currentPrimaryInsuranceId = String(currentPrimarryInsurance.id);
            }
        };
        this.initializeNewMergePatient = () => {
            this.newMergedPatient.clear();
            const { patient: { firstName, middleName, lastName, address, city, state, zip, email, gender, birthDate, notes, phone } } = this.props;
            const birthDateNormalized = moment(birthDate, "YYYY-MM-DD").isValid()
                ? moment(birthDate, "YYYY-MM-DD").format("YYYY-MM-DD")
                : "";
            this.newMergedPatient.set("firstName", firstName);
            this.newMergedPatient.set("middleName", middleName);
            this.newMergedPatient.set("lastName", lastName);
            this.newMergedPatient.set("address", address);
            this.newMergedPatient.set("city", city);
            this.newMergedPatient.set("state", state);
            this.newMergedPatient.set("zip", zip);
            this.newMergedPatient.set("email", email);
            this.newMergedPatient.set("gender", gender);
            this.newMergedPatient.set("birthDate", birthDateNormalized);
            this.newMergedPatient.set("notes", notes);
            this.newMergedPatient.set("phone", phone);
        };
        this.normalizeKey = (key) => {
            switch (key) {
                case "firstName":
                    return "First Name";
                case "middleName":
                    return "Middle Name";
                case "lastName":
                    return "Last Name";
                case "birthDate":
                    return "Birthdate";
                case "address":
                    return "Address"; //C-069
                case "city":
                    return "City";
                case "email":
                    return "Email";
                case "gender":
                    return "Gender";
                default:
                    return "N/A";
            }
        };
        this.handleCheckClick = (field) => () => {
            this.searchParameters[field] = !this.searchParameters[field];
            this.loadSimilarPatients();
        };
        this.handleToggleCollapse = () => (this.showSearchParameters = !this.showSearchParameters);
        this.renderSearchParameters = () => {
            const searchParameters = Object.keys(this.searchParameters).map((key, index) => (React.createElement(checkbox_1.MaterialCheckbox, { key: index, checked: this.searchParameters[key], onAction: this.handleCheckClick(key), label: this.normalizeKey(key) })));
            return (React.createElement("div", null,
                React.createElement(Card_1.CardActions, { style: { display: "flex", justifyContent: "space-between" } },
                    React.createElement(material_ui_1.Typography, null, "Match Parameters"),
                    React.createElement(material_ui_1.IconButton, { onClick: this.handleToggleCollapse, className: "patient-merge-icon-btn" }, this.showSearchParameters ? React.createElement(material_ui_icons_1.ExpandLess, null) : React.createElement(material_ui_icons_1.ExpandMore, null))),
                React.createElement(transitions_1.Collapse, { in: this.showSearchParameters },
                    React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr" } }, searchParameters))));
        };
        this.handleOnCheck = (row) => () => {
            this.checkedPatients.set(row.id, !this.checkedPatients.get(row.id));
            if (this.isValidMergeSelection) {
                this.errorMessage = "";
            }
        };
        this.renderListRow = (row, index) => {
            const isCurrentPatient = row.id === this.props.patient.id;
            return (React.createElement(list_item_1.MaterialListItem, { key: index },
                React.createElement(checkbox_1.MaterialCheckbox, { checked: this.checkedPatients.get(row.id) || false, label: "", onAction: this.handleOnCheck(row), value: String(row.id) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: isCurrentPatient ? "Current Patient" : row.id }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.lastName }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.firstName }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.birthDate })) //C-076 replace firstname to lastname
            );
        };
        this.handleCheckAll = () => {
            if (Array.from(this.checkedPatients.values()).every((isTruthy) => isTruthy)) {
                for (const patient of this.similarPatients) {
                    this.checkedPatients.set(patient.id, false);
                }
            }
            else {
                for (const patient of this.similarPatients) {
                    this.checkedPatients.set(patient.id, true);
                }
            }
            if (this.isValidMergeSelection) {
                this.errorMessage = "";
            }
        };
        this.renderCheckAll = () => (React.createElement(checkbox_1.MaterialCheckbox, { checked: this.isCheckAll, label: "", onAction: this.handleCheckAll }));
        this.renderSimilarPatients = () => (React.createElement(list_1.MaterialList, { checkbox: this.renderCheckAll(), columns: columns, rows: this.similarPatients, renderRow: this.renderListRow }));
        this.handleRowDataSelection = (rowIndex, data) => async () => {
            switch (rowIndex) {
                case PatientDataIndex.FirstName:
                    this.newMergedPatient.set("firstName", data);
                    break;
                case PatientDataIndex.MiddleName:
                    this.newMergedPatient.set("middleName", data);
                    break;
                case PatientDataIndex.LastName:
                    this.newMergedPatient.set("lastName", data);
                    break;
                case PatientDataIndex.Address:
                    this.newMergedPatient.set("address", data);
                    break;
                case PatientDataIndex.City:
                    this.newMergedPatient.set("city", data);
                    break;
                case PatientDataIndex.State:
                    this.newMergedPatient.set("state", data);
                    break;
                case PatientDataIndex.Zipcode:
                    this.newMergedPatient.set("zip", data);
                    break;
                case PatientDataIndex.Email:
                    this.newMergedPatient.set("email", data);
                    break;
                case PatientDataIndex.Gender:
                    this.newMergedPatient.set("gender", data);
                    break;
                case PatientDataIndex.Birthdate:
                    this.newMergedPatient.set("birthDate", data);
                    break;
                case PatientDataIndex.Notes:
                    this.newMergedPatient.set("notes", data);
                    break;
                case PatientDataIndex.Phone:
                    this.newMergedPatient.set("phone", data);
                    break;
                default:
            }
        };
        this.renderMergeUiRow = (row, rowIndex) => (React.createElement(list_item_1.MaterialListItem, { key: rowIndex }, row.map((data, dataIndex) => {
            let normalizedData = data;
            if (rowIndex === PatientDataIndex.Gender) {
                normalizedData = data === "1" ? "Male" : data === "2" ? "Female" : "";
            }
            return (React.createElement(list_item_text_1.MaterialListItemText, { key: dataIndex, onClick: this.handleRowDataSelection(rowIndex, data), primary: normalizedData }));
        })));
        this.renderMergePatientUiRow = (row, rowIndex) => (React.createElement(list_item_1.MaterialListItem, { key: rowIndex }, row.map((data, dataIndex) => {
            let normalizedData = data;
            if (rowIndex === PatientDataIndex.Gender && data !== "Gender") {
                normalizedData = data === "1" ? "Male" : data === "2" ? "Female" : "";
            }
            return (React.createElement(list_item_text_1.MaterialListItemText, { key: dataIndex, primary: normalizedData }));
        })));
        this.handleShowMergeConfirmation = () => {
            if (this.availableInsurances.length && !this.currentPrimaryInsuranceId) {
                this.errorMessage =
                    "Please select a primary insurance before proceeding.";
                return;
            }
            this.showMergeConfirmation = true;
        };
        this.renderPatientMergeUi = () => (React.createElement("div", { style: { maxHeight: "450px" } },
            React.createElement(form_1.UiForm, { buttons: [
                    React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.props.onCancel }, "Cancel"),
                    "Merge Patients"
                ], 
                // onSubmit={() => (this.showMergeConfirmation = true)}
                onSubmit: this.handleShowMergeConfirmation, error: this.errorMessage, shouldDisableSave: Boolean(this.errorMessage) },
                React.createElement(material_ui_1.Typography, { variant: "headline" }, "Merge Patients"),
                React.createElement(material_ui_1.Typography, { variant: "subheading" },
                    "Please update the patient data.",
                    " "),
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: "1rem"
                    } },
                    React.createElement(button_1.MaterialButton, { flat: true, secondary: true, onClick: () => (this.displaySelectUi = true) }, "Back")),
                React.createElement("div", { style: {
                        display: "flex",
                        width: "100%",
                        overflow: "auto",
                        marginBottom: "2rem"
                    } },
                    React.createElement("div", { className: "updated-patient-data-list" },
                        React.createElement(list_1.MaterialList, { columns: [
                                { label: "Field", id: "field" },
                                { label: "Updated Patient", id: "new" }
                            ], rows: this.newMergePatientParsed, renderRow: this.renderMergePatientUiRow })),
                    React.createElement("div", { className: "patient-to-merge-data-list" },
                        React.createElement(list_1.MaterialList, { columns: this.mergeColumns, rows: this.patientsToMerge, renderRow: this.renderMergeUiRow }))),
                React.createElement("div", null,
                    React.createElement(material_ui_1.Typography, { variant: "headline" }, "Insurance"),
                    React.createElement(material_ui_1.Typography, null, "Please select a primary insurance."),
                    this.availableInsurances.length ? (React.createElement(select_1.MaterialSelect, { options: this.availableInsurances, required: Boolean(this.availableInsurances.length), searchable: true, label: "Primary Insurance", onSelect: this.handlePrimaryInsuranceSelect, value: this.currentPrimaryInsuranceId || "" })) : (React.createElement(material_ui_1.Typography, null, "No available insurances"))))));
        this.handlePrimaryInsuranceSelect = (value) => {
            this.currentPrimaryInsuranceId = value;
            if (this.currentPrimaryInsuranceId) {
                this.errorMessage = "";
            }
        };
        this.handleNext = () => {
            if (!this.isValidMergeSelection) {
                this.errorMessage =
                    "At least one patient, excluding the current patient, must be selected";
                return;
            }
            this.initializeNewMergePatient();
            this.displaySelectUi = false;
        };
        this.renderPatientSelectUi = () => (React.createElement(form_1.UiForm, { className: "form-cstm" //C-088
            , error: this.errorMessage, buttons: [
                React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.props.onCancel }, "Cancel"),
                "Next"
            ], onSubmit: this.handleNext, shouldDisableSave: Boolean(this.errorMessage) },
            React.createElement(material_ui_1.Typography, { variant: "headline" }, "Merge Patients"),
            this.renderSearchParameters(),
            React.createElement(material_ui_1.Typography, { variant: "subheading" }, "Please select the patients to be merged"),
            this.renderSimilarPatients()));
        this.handleMergePatientSubmit = () => {
            const updatedPatient = {};
            for (const [key, value] of this.newMergedPatient) {
                updatedPatient[key] = value;
            }
            // Update primaryInsurance
            this.allInsurances = this.allInsurances.map(insurance => {
                const isSelectedPrimaryInsurance = String(insurance.id) === String(this.currentPrimaryInsuranceId);
                insurance.primaryInsurance = isSelectedPrimaryInsurance ? true : false;
                return insurance;
            });
            this.props.onSubmitMerge(updatedPatient, this.selectedPatients, this.allInsurances);
        };
    }
    get availableInsurances() {
        this.allInsurances = this.selectedPatients.reduce((acc, cur) => acc.concat(Array.from(cur.insurances)), []);
        const currentPatientIsSelected = this.selectedPatients.find(patient => patient.id === this.props.patient.id);
        // Ensure that current patient insurances is available for selection.
        if (!currentPatientIsSelected) {
            this.allInsurances = this.allInsurances.concat(Array.from(this.props.patient.insurances));
        }
        return this.allInsurances
            .filter(insurance => !insurance.deletedAt)
            .map((insurance, index) => ({
            id: index,
            label: insurance.insuranceId,
            value: String(insurance.id)
        }));
    }
    get isCheckAll() {
        return Array.from(this.checkedPatients.values()).every((isTruthy) => isTruthy);
    }
    get newMergePatientParsed() {
        const newPatient = [
            ["First Name", this.newMergedPatient.get("firstName") || ""],
            ["Middle Name", this.newMergedPatient.get("middleName") || ""],
            ["Last Name", this.newMergedPatient.get("lastName") || ""],
            ["Address", this.newMergedPatient.get("address") || ""],
            ["City", this.newMergedPatient.get("city") || ""],
            ["State", this.newMergedPatient.get("state") || ""],
            ["Zipcode", this.newMergedPatient.get("zip") || ""],
            ["Email", this.newMergedPatient.get("email") || ""],
            ["Gender", this.newMergedPatient.get("gender") || ""],
            ["Birthdate", this.newMergedPatient.get("birthDate") || ""],
            ["Notes", this.newMergedPatient.get("notes") || ""],
            ["Phone", this.newMergedPatient.get("phone") || ""]
        ];
        return newPatient;
    }
    get mergeColumns() {
        const selectedPatients = this.similarPatients.filter(patient => this.checkedPatients.get(patient.id));
        let duplicateIndex = 1;
        return selectedPatients.map((patient) => {
            const isCurrentPatient = patient.id === this.props.patient.id;
            return {
                id: String(patient.id),
                label: isCurrentPatient
                    ? "Current Patient"
                    : `Duplicate${duplicateIndex++}`
            };
        });
    }
    get selectedPatients() {
        return this.similarPatients.filter(patient => this.checkedPatients.get(patient.id));
    }
    get patientsToMerge() {
        const firstNames = [];
        const middleNames = [];
        const lastNames = [];
        const addresses = [];
        const cities = [];
        const states = [];
        const zipcodes = [];
        const emails = [];
        const genders = [];
        const birthDates = [];
        const notes = [];
        const phones = [];
        for (const patient of this.selectedPatients) {
            firstNames.push(patient.firstName);
            middleNames.push(patient.middleName);
            lastNames.push(patient.lastName);
            addresses.push(patient.address);
            cities.push(patient.city);
            states.push(patient.state);
            zipcodes.push(patient.zip);
            emails.push(patient.email);
            genders.push(patient.gender);
            birthDates.push(patient.birthDate);
            notes.push(patient.notes);
            phones.push(patient.phone);
        }
        const patientsData = [
            firstNames,
            middleNames,
            lastNames,
            addresses,
            cities,
            states,
            zipcodes,
            emails,
            genders,
            birthDates,
            notes,
            phones
        ];
        return patientsData;
    }
    componentWillMount() {
        this.initializePrimaryInsurance();
        this.initializeNewMergePatient();
        this.loadSimilarPatients();
    }
    get isValidMergeSelection() {
        return (this.selectedPatients.filter(patient => patient.id !== this.props.patient.id).length > 0);
    }
    get mergeConfirmationMessage() {
        const normalizeKey = (key) => {
            const re = /([A-Z])/g;
            const strArr = key.replace(re, " $1");
            const [firstLetter, ...restOfString] = strArr;
            return `${firstLetter.toUpperCase()}${restOfString.join("")}`;
        };
        let patientDataHtml = "<p>Confirming will merge the selected patients and update the current patient with the following data: </p>";
        patientDataHtml += `<div style="width: 75%; margin: 0 auto">`;
        for (const [key, value] of this.newMergedPatient) {
            let normalizeValue = value;
            if (key === "gender") {
                normalizeValue = value === "1" ? "Male" : value === "2" ? "Female" : "";
            }
            patientDataHtml += `<p style="margin: 0; text-align: left"><span style="font-weight: 500">${normalizeKey(key)}: </span><span style="color: #00c079">${normalizeValue}</span></p>`;
        }
        patientDataHtml += `</div>`;
        return patientDataHtml;
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(modal_1.Modal, { onCancel: this.props.onCancel, width: "750px", height: "500px" }, this.displaySelectUi
                ? this.renderPatientSelectUi()
                : this.renderPatientMergeUi()),
            this.showMergeConfirmation && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Merge", cancelText: "Cancel", message: this.mergeConfirmationMessage, onCancel: () => (this.showMergeConfirmation = false), onConfirm: this.handleMergePatientSubmit, title: "Patient merge confirmation" }))));
    }
};
__decorate([
    mobx_1.computed
], PatientMergeModal.prototype, "availableInsurances", null);
__decorate([
    mobx_1.computed
], PatientMergeModal.prototype, "isCheckAll", null);
__decorate([
    mobx_1.computed
], PatientMergeModal.prototype, "newMergePatientParsed", null);
__decorate([
    mobx_1.computed
], PatientMergeModal.prototype, "mergeColumns", null);
__decorate([
    mobx_1.computed
], PatientMergeModal.prototype, "selectedPatients", null);
__decorate([
    mobx_1.computed
], PatientMergeModal.prototype, "patientsToMerge", null);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "allInsurances", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "currentPrimaryInsuranceId", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "showMergeConfirmation", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "errorMessage", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "similarPatients", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "showSearchParameters", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "displaySelectUi", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "checkedPatients", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "newMergedPatient", void 0);
__decorate([
    mobx_1.observable
], PatientMergeModal.prototype, "searchParameters", void 0);
__decorate([
    mobx_1.computed
], PatientMergeModal.prototype, "isValidMergeSelection", null);
__decorate([
    mobx_1.computed
], PatientMergeModal.prototype, "mergeConfirmationMessage", null);
PatientMergeModal = __decorate([
    mobx_react_1.observer
], PatientMergeModal);
exports.PatientMergeModal = PatientMergeModal;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/edit-patient/components/patient-merge-modal/patient-merge-modal.tsx
// module id = 3778
// module chunks = 0